export const statusColor = (type: string, value: string) => {
  if (!value) return '';

  switch (type) {
    case 'status':
      if (
        ['approved', 'ordered', 'components arrived', 'in production'].includes(
          value?.toLowerCase()
        )
      )
        return 'table_orange';
      if (['ready', 'installed'].includes(value?.toLowerCase())) return 'table_green';
      if (value?.toLowerCase() === 'new') return 'table_gray';
      return 'table_blue';
    case 'estimate':
      if (value?.toLowerCase() === 'not created') return 'table_gray';
      if (value?.toLowerCase() === 'exported to qb') return 'table_orange';
      if (value?.toLowerCase() === 'sent to customer') return 'table_green';
      return 'table_gray';
    case 'invoice':
      if (value?.toLowerCase() === 'not created') return 'table_gray';
      if (['not paid', 'no'].includes(value?.toLowerCase())) return 'table_red';
      if (value?.toLowerCase() === 'partial') return 'table_orange';
      if (['paid', 'yes'].includes(value?.toLowerCase())) return 'table_green';
      return 'table_gray';
    default:
      return;
  }
};
